/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-extraneous-dependencies */
import { Box } from '@mui/material'
import useAuthContext from 'hooks/useAuthContext'
import useToastify from 'hooks/useToastify'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from 'shared/components'

const Narbar = () => {
  const { handleLogout } = useAuthContext()
  const { showError } = useToastify()
  const navigate = useNavigate()

  const handleLogoutAction = async () => {
    const res = await handleLogout()
    if (res.ErrorCode === 0) {
      setTimeout(() => navigate('/login'), 500)
    } else {
      showError('Đã xảy ra lỗi, vui lòng thử lại sau!')
    }
  }

  return (
    <nav
      className="navbar navbar-top fixed-top navbar-expand"
      id="navbarDefault"
    >
      <div className="collapse navbar-collapse justify-content-between">
        <div className="navbar-logo">
          <button
            className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarVerticalCollapse"
            aria-controls="navbarVerticalCollapse"
            aria-expanded="false"
            aria-label="Toggle Navigation"
          >
            <span className="navbar-toggle-icon">
              <span className="toggle-line"></span>
            </span>
          </button>
          <Link className="navbar-brand me-1 me-sm-3" to="/">
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                <p className="logo-text ms-2 d-none d-sm-block">G-Kitchen</p>
              </div>
            </div>
          </Link>
        </div>

        <ul className="navbar-nav navbar-nav-icons flex-row">
          <Box className="nav-item dropdown">
            <a className="nav-link lh-1 pe-0">
              <div className="avatar avatar-l ">
                <img alt="logo" src="/assets/img/app_logo.jpg" />
              </div>
            </a>
            <Button
              sx={{
                cursor: 'pointer',
                minWidth: 'unset',
                '&:hover': {
                  bgcolor: 'transparent',
                },
              }}
              variant="text"
              color="error"
              width="auto"
              onClick={handleLogoutAction}
            >
              Logout
            </Button>
          </Box>
        </ul>
      </div>
    </nav>
  )
}

export default Narbar
